export default {
  title: 'Zaručené doručení',
  badge: 'Zobrazeno {{read}} z {{total}}',
  Modal: {
    title: 'Zaručené doručení',
    subtitle: 'Přehled, kdo z členů budovy tuto položku zobrazil.',
    read: 'Zobrazeno',
    unread: 'Nezobrazeno',
    noAccount: 'Nemá účet v aplikaci',
    empty: 'Zatím nikdo nezobrazil',
  },
};
